import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { DetailPanel, DetailPanels } from "@/components/organisms";

import { panelContextSchema, panelDescriptionSchema, panelOversightSchema, panelProtectionSchema } from "./panelSchema";

const AccordionIndex = {
    DESCRIPTION: "description",
    CONTEXT: "context",
    SYSTEM_PROTECTION: "protection",
    OVERSIGHT: "oversight",
};

type GoodsTabPanelProps = {
    details: MyBrokerApi.Building;
};

const GoodsTabPanel: FC<GoodsTabPanelProps> = ({ details }) => {
    const { t } = useTranslation();

    return (
        <DetailPanels defaultDetailPanelOpen={AccordionIndex.DESCRIPTION}>
            <DetailPanel
                dataTestId="insured_good_detail_description"
                id={AccordionIndex.DESCRIPTION}
                title={t("Common.Description")}
                infoList={panelDescriptionSchema(details.descriptionDetails)}
            />
            <DetailPanel
                dataTestId="insured_good_detail_context"
                id={AccordionIndex.CONTEXT}
                title={t("InsuredGood.Details.Building.Context")}
                infoList={panelContextSchema(details.contextDetails)}
            />
            <DetailPanel
                dataTestId="insured_good_detail_protection"
                id={AccordionIndex.SYSTEM_PROTECTION}
                title={t("InsuredGood.Details.Building.Protection")}
                infoList={panelProtectionSchema(details.systemProtectionDetails)}
            />
            <DetailPanel
                dataTestId="insured_good_detail_oversight"
                id={AccordionIndex.OVERSIGHT}
                title={t("InsuredGood.Details.Building.Oversight")}
                infoList={panelOversightSchema(details.constructionOversightDetails)}
            />
        </DetailPanels>
    );
};

export default GoodsTabPanel;
